import {defineStore} from 'pinia'
import axios from 'axios'
import Cookies from 'js-cookie'

// Define a new store
export const useProductListStore = defineStore('productList', {
    state: () => ({
        ecommerce: window.ecommerce,
        apiEndpoint: window.app.product_list.api_endpoint,
        layout: window.app.product_list.layout,
        hideSideBar: window.app.product_list.hideSideBar === "1" ? "1" : "0",
        tpgSideBarNavigation: window.app.product_list.tpgSideBarNavigation === "1" ? "1" : "0",
        apiSite: window.app.product_list.api_site,
        showComparelistButton: window.app.product_list.showComparelistButton,
        items: [],
        locale: window.app.product_list.siteLanguage,
        localeHref: window.app.product_list.siteLanguageHrefLang.replace('-', '_'),
        findAttributes: window.app.product_list.findAttributes,
        detailPageUrl: window.app.product_list.detailPageUrl,
        showPrice: window.app.product_list.showPrice,
        showBuyButton: window.app.product_list.enabledBuy,
        showButtonStyle: window.app.product_list.showButtonStyle,
        bazaarvoiceEnabled: window.app.product_list.bazaarvoiceEnabled,
        ratingEnabled: window.app.product_list.ratingEnabled,
        showBuyButtonOnThisWidget: window.app.product_list.showBuyButton,
        shopEnabled: window.app.product_list.shopEnabled,
        loaded: false,
        syliusLoaded: false,
        numberOfTotalItems: 9,
        isEmpty: false,
        pageNumber: 0,
        pageSize: 9,
        totalPages: 10,
        showPopup: false,
        showErrorContent: false,
        isEmptyFilterResult: false
    }),

    getters: {
        apiUrlGet: (state) => {
            return state.apiEndpoint + '/v2/item/find'
        }
    },

    actions: {
        setLoaded(payload) {
            this.loaded = payload
        }, setIsEmptyFilterResult(payload) {
            this.isEmptyFilterResult = payload
        }, setSyliusLoaded(payload) {
            this.syliusLoaded = payload
        }, setItems(payload) {
            this.items = [...payload]
        }, addItems(payload) {
            this.items = [...this.items, ...payload]
        }, setPageSize(payload) {
            this.pageSize = payload
        }, setNumberOfTotalItems(payload) {
            this.numberOfTotalItems = payload
        }, setPageNumber(payload) {
            this.pageNumber = payload
        }, setTotalPages(payload) {
            this.totalPages = payload
        }, setIsEmpty(payload) {
            this.isEmpty = payload
        }, setShowPopup(payload) {
            this.showPopup = payload
        }, setShowErrorContent(payload) {
            this.showErrorContent = payload
        }, setURLParams() {
            const url = new URL(window.location.href)
            url.searchParams.set('pageNumber', this.pageNumber + 1)
            window.history.pushState({}, '', url)
        }, setPredefinedFilter() {
            const url = new URL(window.location.href)
            if (url.searchParams.has('pageNumber')) {
                if (url.searchParams.get('pageNumber') == 0) {
                    this.pageNumber = 0
                } else {
                    this.pageNumber = parseInt(url.searchParams.get('pageNumber') - 1)
                }

            }
        }, async get() {
            // If URL has filters that require itemNumbers, wait until the filter store computed them.
            const sp = new URL(window.location.href).searchParams

            if (this.hideSideBar === "0" && this.tpgSideBarNavigation === "0") {
                const hasPc = !!sp.get('productCategory')?.trim()
                const hasPrice = !!sp.get('salesPrice')?.trim() || (
                    sp.has('salesPriceMin') || sp.has('salesPriceMax')
                )

                if ((hasPc || hasPrice) && !this.findAttributes.itemNumbers) return
            }

            this.setLoaded(false)
            this.setSyliusLoaded(false)

            const url = new URL(this.apiUrlGet)

            // Prefer itemNos; if they exist, skip classifications
            if (this.findAttributes.itemNumbers && this.hideSideBar === "0" && this.tpgSideBarNavigation === "0") {
                url.searchParams.set('itemNos', this.findAttributes.itemNumbers)
            } else if (this.findAttributes.classifications) {
                url.searchParams.set('classifications', this.findAttributes.classifications)
            }

            if (this.findAttributes.brand) url.searchParams.set('brand', this.findAttributes.brand)
            if (this.findAttributes.productFamily) url.searchParams.set('productFamily', this.findAttributes.productFamily)
            if (this.findAttributes.division) url.searchParams.set('division', this.findAttributes.division)
            if (this.locale) url.searchParams.set('locale', this.localeHref)
            if (this.apiSite) url.searchParams.set('site', this.apiSite)

            url.searchParams.set('pageSize', this.pageSize)
            url.searchParams.set('pageNumber', this.pageNumber)

            try {
                const response = await axios.get(url, {timeout: 5000})
                this.setItems(response.data.content)
                this.setIsEmpty(response.data.empty)
                this.setTotalPages(response.data.totalPages)
                this.setLoaded(true)
            } catch (error) {
                this.setShowErrorContent(true)
            }
            this.setURLParams()
        }, handleSyliusCall() {
            const syliusObj = window.ecommerce.ecommerce
            syliusObj.isProductInSylius()

            setTimeout(() => {
                this.setSyliusLoaded(true)
                this.pushItemsToDatalayer()
            }, 1000)
        }, pushItemsToDatalayer() {
            if (this.showBuyButton === '1' && typeof dataLayer !== 'undefined') {
                let itemsArray = []
                this.items.forEach((item, index) => {
                    if (item.price && item.price.price) {
                        let price = document.querySelector('.card__card[data-itemno="' + item.itemNo + '"] .price__price').getAttribute('data-price')
                        let obj = {
                            item_id: item.itemNo,
                            item_name: item.description,
                            item_brand: item.brand,
                            item_category: item.tpgCode,
                            index: index,
                            price: price,
                        }
                        itemsArray.push(obj)
                    }
                })
                dataLayer.push({ecommerce: null}) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'view_item_list', ecommerce: {
                        item_list_id: window.location.pathname,
                        item_list_name: window.app.product_list.itemlistname,
                        items: itemsArray
                    }
                })
            }
        }, updateCurrentPageNumber(payload) {
            this.setPageNumber(payload)
            this.get().then(() => {
                this.handleSyliusCall()
            })
        }, updateShowPopup(payload) {
            this.setShowPopup(payload)
        }, addToCompareList(payload) {
            let cookie = Cookies.get('clid')
            if (cookie) {
                let ascii = atob(cookie)
                if (ascii.indexOf(payload) === -1) {
                    let newString = ascii + ',' + payload
                    Cookies.set('clid', btoa(newString), {expires: 7})
                }
            } else {
                Cookies.set('clid', btoa(payload), {expires: 7})
            }
            this.setShowPopup(true)
        }
    }
})
